<template>
  <div>
    <SimpleFieldList
      :disabled="disabled"
      :operators="operators"
      :spr="biddingTypes"
      :value.sync="mutableValue"/>
  </div>
</template>
<script>
import SimpleFieldList from 'components/automation/conditions/default/simpleFieldList.vue'
/**
 * 1
 */
export default {
  name: 'tenderType',
  computed: {
    biddingTypes() {
      return this.$store.getters.getBiddingTypes.map(i => ({
        key: i.biddingTypeId,
        label: i.titleRu
      }))
        .sort((a,b) => a.label?.localeCompare(b.label))
    },
    mutableValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  components: {
    SimpleFieldList
  },
  created() {
    this.$store.dispatch('setBiddingTypes')
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
